var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectUsageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2571 14C28.2571 21.732 21.9891 28 14.2571 28C6.52509 28 0.25708 21.732 0.25708 14C0.25708 6.26801 6.52509 0 14.2571 0C21.9891 0 28.2571 6.26801 28.2571 14ZM6.58098 14C6.58098 18.2394 10.0177 21.6761 14.2571 21.6761C18.4965 21.6761 21.9332 18.2394 21.9332 14C21.9332 9.76061 18.4965 6.3239 14.2571 6.3239C10.0177 6.3239 6.58098 9.76061 6.58098 14Z",
    fill: "#EA4903",
    fillOpacity: 0.27
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4495 4.80761C23.84 4.41709 23.8422 3.78085 23.4248 3.41918C21.1394 1.43882 18.2727 0.25139 15.2563 0.0356747C14.7054 -0.00372135 14.2571 0.447715 14.2571 1V5.25567C14.2571 5.80796 14.7067 6.24901 15.2544 6.32012C16.6114 6.49632 17.8982 7.02933 18.9824 7.86433C19.4199 8.20132 20.0497 8.20735 20.4403 7.81683L23.4495 4.80761Z",
    fill: "#EA4903"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectUsageIcon);
export default __webpack_public_path__ + "static/media/object-usage-icon.84a09fd393563fbd9031ec038239fd37.svg";
export { ForwardRef as ReactComponent };